import { render, staticRenderFns } from "./join-list.vue?vue&type=template&id=324fa6b4&scoped=true"
import script from "./join-list.vue?vue&type=script&lang=js"
export * from "./join-list.vue?vue&type=script&lang=js"
import style0 from "./join-list.vue?vue&type=style&index=0&id=324fa6b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324fa6b4",
  null
  
)

export default component.exports